<template>
  <div>
    <!--发布工作需求-->
    <p style="text-align: center">
      <span class="systemFont0">{{ $t("demandMgt.postJobRequirements") }}</span>
    </p>
    <div class="main">
      <el-form
        ref="formDataRef"
        :model="formData"
        :rules="formDataRules"
        label-width="110px"
        style="width:98%;"
      >
        <!--  工作需求标题-->
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$t('demandMgt.jobTitle')"
              prop="jobTitle"
            >
              <el-input
                v-model="formData.jobTitle"
                :disabled="disableFlag()"
                maxlength="125"
                size="small"
                type="text"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--  工作需求内容  -->
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$t('demandMgt.jobDescription')"
              prop="jobDescription"
            >
              <el-input
                v-model="formData.jobDescription"
                :disabled="disableFlag()"
                :rows="10"
                resize="none"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- 需要人数 -->
            <el-form-item :label="$t('demandMgt.numberOfWorkers')" prop="numberOfWorkers">
              <el-input-number
                v-model="formData.numberOfWorkers"
                :disabled="disableFlag()"
                :max="99"
                :min="1"
                size="small"
                style="width: 100%"
                @keyup.native="UpNumber"
                @keydown.native="UpNumber"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 工作时间 -->
            <el-form-item
              :label="$t('demandMgt.jobTime')"
              prop="startTime"
            >
              <el-date-picker
                v-model="formData.startTime"
                :disabled="disableFlag()"
                :picker-options="pickerOptions"
                :placeholder="$t('common.pleaseSelect')"
                format="yyyy-MM-dd HH:mm"
                size="small"
                style="width: calc(50% - 1.1rem)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm"
              >
              </el-date-picker>
              <span style="width: 24px;display: inline-block;"
              >&nbsp;{{ $t("demandMgt.to") }}&nbsp;</span
              >
              <el-date-picker
                v-model="formData.endTime"
                :disabled="disableFlag()"
                :picker-options="pickerOptions"
                :placeholder="$t('common.pleaseSelect')"
                format="yyyy-MM-dd HH:mm"
                size="small"
                style="width: calc(50% - 1.1rem)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6"></el-col>
        </el-row>
        <el-row>
          <!-- 标签 -->
          <el-col :span="6">
            <el-form-item ref="tagListRef" :label="$t('p0213.tag')" prop="tagList">
              <el-select
                v-model="formData.tagList"
                :disabled="disableFlag()"
                :min-rows="1"
                :placeholder="$t('common.pleaseSelect')"
                clearable
                filterable
                multiple
                size="small"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in tagOpList"
                  :key="item.codeKey"
                  :label="item.codeValue"
                  :value="item.codeKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 区域 -->
          <el-col :span="12">
            <el-form-item
              :label="$t('p0213.region')"
              prop="country"
            >
              <RegionSelection ref="RegionSelectionRef" :disabled="disableFlag()" :formData="formData"/>
            </el-form-item>
          </el-col>
          <!-- 分区 -->
          <el-col :span="6">
            <el-form-item
              :label="$t('demandMgt.subarea')"
              prop="subarea"
            >
              <el-input
                v-model="formData.subarea"
                :placeholder="$t('demandMgt.searchKey')"
                :disabled="disableFlag()"
                maxlength="64"
                size="small"
                type="text"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 查询、重置 -->
      <el-row>
        <!-- 查询 -->
        <el-button v-if="!disableFlag()" style="margin-bottom: 30px" type="submit" @click="query(1)"
        ><span>{{ $t("common.query") }}</span>
        </el-button>
        <!-- 重置 -->
        <el-button v-if="!disableFlag()" class="buttonReset" type="submit" v="formData.status!==0" @click="reset()"
        ><span>{{ $t("common.reset") }}</span>
        </el-button>
      </el-row>
      <!--人员表格-->
      <el-row v-if="showFlag" style="margin-top: 20px;overflow: auto;">
        <el-table
          ref="tableDataRef"
          :data="tableData"
          :row-key="getRowKey"
          style="width:100%;margin:auto"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            :reserve-selection="true"
            :selectable="selected"
            align="center"
            type="selection"
            min-width="42"
          ></el-table-column>
          <!-- 头像 -->
          <!-- <el-table-column
            :label="$t('newYouHuiMa.avatar')"
            align="center"
            min-width="60"
          >
            <template slot-scope="scope">
              <el-avatar
                :key="scope.row.headPortrait"
                :size="30"
                :src="viewHeadPortrait(scope.row.headPortrait)"
              ></el-avatar>
            </template>
          </el-table-column> -->
          <!-- 姓名-->
          <el-table-column
            :label="$t('newYouHuiMa.name')"
            fixed="left"
            align="left"
            min-width="118"
          >
            <!-- 姓名 -->
            <template slot-scope="scope">
              {{ scope.row.lastName + " " + scope.row.firstName }}
            </template>
          </el-table-column>
          <!-- 手机号码 -->
          <el-table-column
            :label="$t('newYouHuiMa.phoneNumber')"
            align="center"
            min-width="136"
          >
            <!-- 手机号码 -->
            <template slot-scope="scope">
              {{
                scope.row.phoneNo === null
                  ? scope.row.supplyPhoneNumber
                  : scope.row.phoneArea + " " + scope.row.phoneNo
              }}
            </template>
          </el-table-column>
          <!-- 邮箱 -->
          <el-table-column
            :label="$t('emailGroup.email')"
            align="left"
            min-width="224"
          >
            <template slot-scope="scope">
              {{ scope.row.email || scope.row.supplyEmail }}
            </template>
          </el-table-column>
          <!-- 标签 -->
          <el-table-column
            :label="$t('resourceUserQuery.tag')"
            align="left"
            min-width="156"
            prop="tag"
          >
            <template slot-scope="scope">
              <span :style="scope.row.tagFlag === '1'?'color:red':''">{{ scope.row.tag }}</span>
            </template>
          </el-table-column>
          <!-- 区域 -->
          <el-table-column
            prop="region"
            :label="$t('resourceUserQuery.region')"
            align="left"
            min-width="200"
          >
            <template slot-scope="scope">
              <div :style="scope.row.regionFlag === '1'?'color:red':''" v-for="(item,index) in scope.row.userLocationList" :key="'region'+index">
                {{item.countryName}}{{item.provinceName}}{{item.cityName}}{{item.areaName}}
              </div>
            </template>
          </el-table-column>
          <!-- 分区 -->
          <el-table-column
            :label="$t('resourceUserQuery.subarea')"
            align="left"
            min-width="180"
            prop="subarea"
          >
            <template slot-scope="scope">
              <span :style="scope.row.subareaFlag === '1'?'color:red':''">{{ scope.row.subarea }}</span>
            </template>
          </el-table-column>
          <!-- 接受状态 -->
          <el-table-column
            v-if="formData.status===1"
            :label="$t('demandMgt.acceptFlag')"
            align="center"
            min-width="86"
            prop="acceptFlag"
            fixed="right"
          >
            <template slot-scope="scope">
              <span :style="`color: ${acceptFlagFormat(scope.row).color}`">{{
                  acceptFlagFormat(scope.row).value
                }}</span>
            </template>
          </el-table-column>
          <!--操作-->
          <el-table-column
            v-if="formData.status===1"
            :label="$t('common.operation')"
            align="center"
            width="86"
            fixed="right"
          >
            <template slot-scope="scope">
              <!-- 再次发送 -->
              <el-button @click="sendWxAgain(scope.row)" v-if="scope.row.acceptFlag === '0'" type="text"><span>{{$t('demandMgt.sendAgain')}}</span></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <!-- 发布、保存、返回 -->
      <el-row v-if="showFlag" class="foot-container">
        <!-- 发布 -->
        <el-button style="margin-bottom: 30px" type="submit" @click="submit(1)"><span>{{
            $t("demandMgt.publish")
          }}</span>
        </el-button>
        <!-- 保存 -->
        <el-button v-if="formData.status!==1" style="margin-bottom: 30px" type="submit"
                   @click="submit(formData.status?formData.status:0)"><span>{{ $t("common.save") }}</span>
        </el-button>
        <!-- 返回 -->
        <el-button type="return" @click="returnPage()"><span>{{ $t("common.back") }}</span>
        </el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import RegionSelection from "./RegionSelection.vue"
import moment from "moment/moment";

export default {
  computed: {
    moment() {
      return moment
    }
  },
  components: {
    RegionSelection,
  },
  data() {
    return {
      activeName: "first",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      formData: {
        jobTitle: '',
        jobDescription: '',
        numberOfWorkers: '',
        startTime: null,
        endTime: null,
        tagList: [],
        country: 'AREA-101',
        province: '',
        city: '',
        area: '',
        subarea: '',
        demandUserList: [],
        selectedDemandUserList: []
      },
      tagList: [],
      country: '',
      province: '',
      city: '',
      area: '',
      subarea: '',
      selection: [],
      tableData: [],
      showFlag: false,
      defaultImg: require("@/assets/headPortrait.png"),
      formDataRules: {
        jobTitle: {
          required: true,
          message: this.$t("demandMgt.pleaseEnter"),
          trigger: "blur"
        },
        jobDescription: {
          required: true,
          message: this.$t("demandMgt.pleaseEnter"),
          trigger: "blur"
        },
        numberOfWorkers: {
          required: true,
          message: this.$t("demandMgt.pleaseEnter"),
          trigger: "blur"
        },
        startTime: {
          required: true,
          message: this.$t("demandMgt.pleaseEnter"),
          trigger: "change"
        },
        tagList: {
          required: true,
          message: this.$t("demandMgt.pleaseEnter"),
          trigger: "change"
        },
        country: {
          required: true,
          message: this.$t("demandMgt.pleaseEnter"),
          trigger: "change"
        },
      },
      tagOpList: [],
      titleHead: ""
    };
  },
  // 监听
  watch: {},
  methods: {
    sendWxAgain(row){
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/demand/sendWxNotice";
      let formData = this.formData;
      formData.createUser = localStorage.userId
      formData.tagList = this.tagList
      formData.country = this.country
      formData.province = this.province
      formData.city = this.city
      formData.area = this.area
      formData.subarea = this.subarea
      formData.demandUserList = [row]
      this.$http
        .post(url, formData)
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            this.$message({
              type: "success",
              message: this.$t("demandMgt.msg9")
            });
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(()=>{
          loading.close();
      });
    },
    acceptFlagFormat(row) {
      switch (row.acceptFlag) {
        // 未回应
        case '0':
          return {value: this.$t('demandMgt.noResponse'), color: ''}
        // 已接受
        case '1':
          return {value: this.$t('demandMgt.accepted'), color: '#02D764'}
        // 已拒绝
        case '2':
          return {value: this.$t('demandMgt.rejected'), color: '#FD5B4D'}
        default:
          return {value: '', color: ''}
      }
    },
    // 只可输入数字
    UpNumber(e) {
      e.target.value = e.target.value.replace(/[^\d]/g, '')
    },
    disableFlag() {
      return this.formData.status === 1 || this.formData.status === 3;
    },
    // 不可选择
    selected(row, index) {
      if (row.noticeFlag === '1' || row.tagFlag || row.regionFlag || row.subareaFlag) {
        //不可选择
        return false;
      } else {
        //可选择
        return true;
      }
    },
    // 手动选择
    toggleSelection(rows) {
      this.$refs.tableDataRef.clearSelection();
      if (rows) {
        rows.forEach(row => {
          this.$refs.tableDataRef.toggleRowSelection(row);
        });
      } else {
        this.$refs.tableDataRef.clearSelection();
      }
    },
    // 选择的用户
    handleSelectionChange(val) {
      if (!val[0]) {
        this.selection = [];
      }
      this.selection = val.map(item => {
        return item.userId;
      });
      // 带入待提交列表
      this.formData.demandUserList = []
      this.selection.forEach(item => {
        this.formData.demandUserList.push(this.tableData.filter(table => table.userId === item)[0])
      })
    },
    // 获取key
    getRowKey(row) {
      return row.userId;
    },
    // 头像图片显示
    viewHeadPortrait(imgCodeStr) {
      return imgCodeStr == null
        ? this.defaultImg
        : "data:image/png;base64," + imgCodeStr;
    },
    // 初始化
    async init() {
      let url = "/api/demand/getEdit";
      await this.$http
        .post(url, this.formData)
        .then(async response => {
          if (response.data.code === 200) {
            this.formData = response.data.data
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取option
    async getTagOption() {
      let url = "/api/demand/getTagOption";
      await this.$http
        .post(url)
        .then(response => {
          if (response.data.code === 200) {
            this.tagOpList = response.data.data
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 提交
    async submit(val) {
      if (await this.verify(val === 1 ? 1 : 2)) {
        const loading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          background: "rgba(255,255,255,0.8)",
          target: document.querySelector("#main-container")
        });
        let url = "/api/demand/editDemand";
        this.formData.createUser = localStorage.userId
        this.formData.tagList = this.tagList
        this.formData.country = this.country
        this.formData.province = this.province
        this.formData.city = this.city
        this.formData.area = this.area
        this.formData.subarea = this.subarea
        this.$http
          .post(url, {...this.formData, status: val})
          .then(response => {
            loading.close();
            if (response.data.code === 200) {
              this.$message({
                type: "success",
                message: this.$t("p0433.operationSuccess")
              });
              this.returnPage();
            }
          })
          .catch(error => {
            loading.close();
            this.$message.error(error.data.message);
            console.log(error);
          });
      }
    },
    // 返回
    returnPage() {
      this.$router.push({
        path: "/views/ResourceBaseManagement/DemandMgt/Index",
        query: {
          ...this.$route.query
        }
      });
    },
    // 验证 0 查询 ，1 发布，2保存
    async verify(val) {
      let flag = 0;
      if (val === 0) {
        await this.$refs.formDataRef.validateField('tagList', valid => {
          if (valid) {
            flag++;
          }
        })
        await this.$refs.RegionSelectionRef.$refs.formDataRef.validateField(['country', 'province', 'city', 'area'], valid => {
          if (valid) {
            flag++;
          }
        })
      }
      if (val === 1) {
        await this.$refs.formDataRef.validate(valid => {
            if (!valid) {
              flag++;
            }
          }
        )
        await this.$refs.RegionSelectionRef.$refs.formDataRef.validateField(['country', 'province', 'city', 'area'], valid => {
          if (valid) {
            flag++;
          }
        })
        if (flag === 0) {
          // 发布后不检测日期时间
          if (this.formData.status !== 1) {
            const startTime = new Date(this.formData.startTime);
            const endTime = new Date(this.formData.endTime);
            // 获取当前日期
            const currentDate = new Date();
            currentDate.setSeconds(0, 0);
            // 工作开始时间需要大于当前时间
            if (startTime < currentDate) {
              this.$message.error(this.$t('demandMgt.msg5'))
              return false
            }
            // 工作结束时间需要大于开始时间
            if (this.formData.endTime ? startTime >= endTime : false) {
              this.$message.error(this.$t('demandMgt.msg6'))
              return false
            }
          }
          // 请选择人员
          if (!this.formData.demandUserList || this.formData.demandUserList.length === 0) {
            this.$message.error(this.$t('demandMgt.msg7'))
            return false
          }
          // 请选择未发送的人员
          if (!this.formData.demandUserList.find(item => !item.noticeFlag)) {
            this.$message.error(this.$t('demandMgt.msg8'))
            return false
          }
        }
      }
      if (val === 2) {
        await this.$refs.formDataRef.validateField('jobTitle', valid => {
          if (valid) {
            flag++;
          }
        })
      }
      return flag === 0;
    },
    // 查询
    async query(val) {
      if (await this.verify(0)) {
        this.$refs.RegionSelectionRef.handleRegionCode()
        this.tagList = this.formData.tagList
        this.country = this.formData.country
        this.province = this.formData.province
        this.city = this.formData.city
        this.area = this.formData.area;
        this.subarea = this.formData.subarea;
        let url = "/api/demand/getDemandUserList";
        await this.$http
          .post(url, this.formData)
          .then(response => {
            if (response.data.code === 200) {
              this.tableData = response.data.data
              // 写入禁用(提交状态)
              if (this.formData.status === 1) {
                this.tableData.forEach(item => {
                  if (this.formData.selectedDemandUserList.some(user => user.noticeFlag === '1' && user.userId === item.userId)) {
                    item.noticeFlag = this.formData.selectedDemandUserList.filter(user => user.userId === item.userId)[0].noticeFlag
                    item.acceptFlag = this.formData.selectedDemandUserList.filter(user => user.userId === item.userId)[0].acceptFlag
                  }
                })
                // 排序
                this.tableData.sort((a, b) => {
                  if (a.noticeFlag === '1' && b.noticeFlag !== '1') {
                    return -1; // a 在 b 前面
                  } else if (a.noticeFlag !== '1' && b.noticeFlag === '1') {
                    return 1; // b 在 a 前面
                  } else {
                    return 0; // 保持原样
                  }
                });
              }
              if (val !== 1 && (this.formData.status === 1 || this.formData.status === 2)) {
                for (let i = 0; i < this.formData.selectedDemandUserList.length; i++) {
                  const user = this.formData.selectedDemandUserList[i];
                  const foundIndex = this.tableData.findIndex(item => item.userId === user.userId); // 假设用户对象有一个id属性来标识唯一性
                  if (foundIndex === -1) {
                    // 获取当前选中的区域字符串
                    user.regionFlag = "1";
                    const selectedRegion = this.$refs.RegionSelectionRef.selectRegionString();
                    for (const uElement of user.userLocationList) {
                      let region = uElement.countryName + uElement.provinceName + uElement.cityName + uElement.areaName;
                      // 如果找到匹配的区域，设置 flag 并跳出循环
                      if (region === selectedRegion) {
                        user.regionFlag = "0";
                        break;
                      }
                    }
                    // 使用 filter 方法进行筛选
                    if (user.subarea && user.subarea.indexOf(this.subarea) === -1) {
                      user.subareaFlag = "1"
                    }
                    const filterTags = this.filterTags();
                      try {
                        const tagArray = user.tag.split(";");
                        const allTagsExist = filterTags.every(tag => tagArray.includes(tag));
                        if (!allTagsExist) {
                          user.tagFlag = '1'
                        }
                      } catch (e) {
                        console.log(e)
                      }
                    this.tableData.unshift(user); // 将用户添加到数组最前面
                  }
                }
              }
              this.showFlag = true
              if (val !== 1) {
                this.$nextTick(() => {
                  // 写入选中
                  let row = this.tableData.filter(item => {
                    // 取消状态禁用不属于标签区域的人
                    let flag = this.formData.status === 1 ? true : !item.regionFlag && !item.subareaFlag && !item.tagFlag
                    return this.formData.selectedDemandUserList.some(user => user.userId === item.userId && flag)
                  })
                  this.toggleSelection(row)
                })
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    filterTags() {
      const filteredItems = this.tagOpList.filter(op => {
        // 检查每个元素的 codeKey 是否在 formData.tagList 中
        return this.formData.tagList.includes(op.codeKey);
      }).map(op => op.codeValue);
      return filteredItems;
    },
    // 重置搜索条件
    reset() {
      // this.formData.tagList=[]
      this.tableData = []
      this.showFlag = false
      this.$refs.tagListRef.resetField();
      this.$refs.RegionSelectionRef.clearProvince()
    },
  }
  ,
  async mounted() {
    if (this.$route.query.demandId) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      this.formData.demandId = this.$route.query.demandId;
      await this.init()
      await this.$refs.RegionSelectionRef.getChineArea()
      await this.getTagOption()
      await this.query()
      loading.close()
    } else {
      await this.$refs.RegionSelectionRef.getChineArea()
      await this.getTagOption()
    }
  }
}
;
</script>

<style lang="scss" scoped>
.main {
  width: 76%;
  margin: 0 auto;
  padding-top: 17px;
}

@media screen and (max-width: 1680px) {
  .main {
    width: 93%;
    margin: 0 auto;
    padding-top: 17px;
  }
}

@media screen and (max-width: 1366px) {
  .main {
    width: 98%;
    margin: 0 auto;
    padding-top: 17px;
  }
}

.foot-container {
  margin-top: 5%;
  // margin-left: 38%;
  margin: 5% auto;
  width: 30%;
  text-align: center;
}

>>> .el-table__row {
  height: 42px;
}

> .el-table .cell {
  line-height: 28px;
}

>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 14px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .buttonReset {
  width: 61px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 176, 240);
}
</style>



// WEBPACK FOOTER //
// src/views/ResourceBaseManagement/DemandMgt/Edit.vue